import { CalEvent } from './CalEvent';
import { Patron } from './Patron';

export class MultiDayEvent extends CalEvent {

    masterEventId;

    patronCheckInMap;   // slaves only: map of patron id to number of check-ins for this event
    masterPatrons;      // slaves only: the list of patrons in the master event (for frontend display purposes only)
    slaveTotalCheckIns;      // slaves only: total number of check-ins across all patrons for this event (for frontend display purposes only)
    slaveTotalPatronCount;   // slaves only: total number of patrons signed up for this event (for frontend display purposes only)

    constructor(json, timezone) {
        super(json, timezone);
        if (json) {
            this.masterEventId = json.masterEventId;
            if (!this.isMaster()) {
                this.visibility = CalEvent.Visibility.INTERNAL.enumName;  // slaves cannot be seen
                this.patronCheckInMap = json.patronCheckInMap ? json.patronCheckInMap : {};
                this.masterPatrons = json.masterPatrons ? json.masterPatrons.map(p => new Patron(p)) : [];
                this.slaveTotalCheckIns = json.totalCheckIns ? json.totalCheckIns : 0;
                this.slaveTotalPatronCount = json.totalPatronCount ? json.totalPatronCount : 0;
            }
        }
    }

    static createNew(start, end, resource) {
        const mdEvent = new MultiDayEvent();
        mdEvent.type = "MultiDayEvent";
        mdEvent.title = "Untitled MultiDayEvent";
        mdEvent.newEvent(start, end, resource, "me");
        mdEvent.masterEventId = mdEvent.id;     // for a new MultiDayEvent, the masterEventId is the same as its own id
        return mdEvent;
    }

    copy() {
        let copy = new MultiDayEvent();
        copy = super.eventCopy(copy);
        copy.masterEventId = this.masterEventId;
        copy.patronCheckInMap = this.patronCheckInMap ? { ...this.patronCheckInMap } : {};
        copy.masterPatrons = this.masterPatrons ? this.masterPatrons.map(p => p.copy()) : [];
        copy.slaveTotalCheckIns = this.slaveTotalCheckIns;
        copy.slaveTotalPatronCount = this.slaveTotalPatronCount;
        return copy;
    }

    isMaster() {
        return this.id === this.masterEventId;
    }


    // override
    symbol() {
        let text = super.symbol();
        if (this.state === "ACTIVE" && this.isMaster())
            return text.replace("💙", "Ⓜ️");

        return text;
    }

    // override
    canManageSignup() {
        return this.isMaster();
    }

    // override
    refreshSignupsAndJournalFrom(refreshedEvent) {
        super.refreshSignupsAndJournalFrom(refreshedEvent);
        if (!this.isMaster()) {
            this.patronCheckInMap = refreshedEvent.patronCheckInMap;
            this.masterPatrons = refreshedEvent.masterPatrons;
            this.slaveTotalCheckIns = refreshedEvent.slaveTotalCheckIns;
            this.slaveTotalPatronCount = refreshedEvent.slaveTotalPatronCount;
        }
    }


    // override
    totalPatronCount() {
        if (this.isMaster())
            return super.totalPatronCount();
        else
            return this.slaveTotalPatronCount;
    }

    // override
    checkedInCount() {
        if (this.isMaster())
            return super.checkedInCount();
        else
            return this.slaveTotalCheckIns;
    }
    

}